export const normalizeDateToISOString = (date: null | string | Date) => {
  if (!date) return null;
  if (typeof date === 'string') date = new Date(date);
  return date.toISOString();
};
